module.exports = __webpack_public_path__ + "static/media/Facebookicon.5d6ea38a.png";